import { render, staticRenderFns } from "./SummaryDialog.vue?vue&type=template&id=712485f8&"
import script from "./SummaryDialog.vue?vue&type=script&lang=ts&"
export * from "./SummaryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports